/*!
 * object-descriptors v0.1.0
 * (c) 2018-present Vitor Luiz Cavalcanti <vitorluizc@outlook.com> (https://vitorluizc.github.io)
 * Released under the MIT License.
 */

/**
 * Get a collection of keys from an object.
 * @param object
 */
var getKeys = function getKeys(object) {
  if (typeof Reflect === 'object' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  if (typeof Object.getOwnPropertySymbols !== 'function') {
    return Object.getOwnPropertyNames(object);
  }

  var keys = [];
  return keys.concat(Object.getOwnPropertyNames(object), Object.getOwnPropertySymbols(object));
};
/**
 * Get an object with all object property descriptors.
 * @param object
 */


var getDescriptors = function getDescriptors(object) {
  if (typeof Object.getOwnPropertyDescriptors === 'function') {
    return Object.getOwnPropertyDescriptors(object);
  }

  var descriptors = getKeys(object).reduce(function (descriptors, key) {
    var descriptor = Object.getOwnPropertyDescriptor(object, key);

    if (descriptor) {
      descriptors[key] = descriptor;
    }

    return descriptors;
  }, {});
  return descriptors;
};

export default getDescriptors;